export default "__VITE_ASSET__tY1hStqZ__"